// extracted by mini-css-extract-plugin
module.exports = {"container":"single-module--container--sqPEp","footer":"single-module--footer--1AwSq"};